'use client';

import { ServiceBotPage } from '../../../features/service-bot';

interface ServiceBotContentProps {
  locale: string;
}

export function ServiceBotContent({ locale }: ServiceBotContentProps) {
  return <ServiceBotPage locale={locale} />;
}
